import type { FaireProductEntity } from "../../entity_types/product";

export const p_8yyfkkmqnj: FaireProductEntity = {
  token: "p_8yyfkkmqnj",
  type: "product",
  name: "Sparkling Cross Rhinestone Gold-Dipped Stud Earrings",
  brandToken: "b_k2cxrcr92s",
  brandName: "Frem",
  imageUrl:
    "https://cdn.faire.com/fastly/2dd97923746fcab4ebbc879ced8f9fa8324d975d6f69f9a19c1eac908a03e7e0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e4e81fee6785a07da0375859a81050023ddaf7127c3966b5305ca5c30f77ca16.jpeg",
    "https://cdn.faire.com/fastly/685b23c3da3de9034b2aaa6ec3595582ef866559f8551f234b3060c236457015.jpeg",
    "https://cdn.faire.com/fastly/a912f81671d2c255a7ac1da4d0d133c9890a9fc0c0fd9037618aec6c953f71b9.jpeg",
  ],
  priceDollars: 11.09,
  description:
    "Add a timeless touch of faith and elegance with these Gold Dipped CZ Cross Stud Earrings. Designed with sparkling cubic zirconia stones set in a sleek gold-dipped finish, these minimalist studs offer everyday shine with meaningful symbolism. Lightweight, polished, and perfect for stacking or wearing solo.\n\nMaterial: Brass, Gold Dipped, Cubic Zirconia\nStyle: Minimalist, dainty, faith-inspired\nPerfect For: Daily wear, gifting, religious occasions, subtle sparkle\n",
  tags: [],
  msrpDollars: 33.26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:55.780Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
